import { makeModuleStateSelector } from "@client/content/selectors";
import { parseQueryString } from "@client/lib/api";
import { TargetSelector, getSettingValueSelector, pageSubTypeSelector } from "@client/selectors";
import { isUuid } from "@common/lib/misc";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import type { Form } from "./types";

export const localStateSelector = makeModuleStateSelector<Form.AppState>(defaultState, previewState);

export const makeFormIdSelector = () => {
  const formSettingsSelector = getSettingValueSelector(TargetSelector.Entity, "form");

  return createSelector([formSettingsSelector, pageSubTypeSelector], (formId, pageSubType) => {
    const qs = parseQueryString();
    const qsFormId = qs.f && isUuid(qs.f) ? qs.f : null;
    if (pageSubType === "Survey") return qsFormId;

    return formId;
  });
};
